import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import NavigationMenu from "./navigationMenu";
import constants, { leftNavItems, rightNavItems } from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

const DesktopNav = ({ pathname }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const { getCurrentLogo } = useUserParams();

  const handleMenuHover = (menu) => {
    setActiveMenu(menu);
  };

  return (
    <div className="relative bg-white w-full px-8 min-h-10 flex items-center justify-between">
      {/* Floating Logo */}
      <div className="absolute left-1/2 -translate-x-1/2 top-2 z-20 pointer-events-none">
        <div className="border-[12px] border-[#8B5C2A] p-2 bg-white shadow-lg">
          <img
            src={getCurrentLogo()}
            alt="Logo"
            width={200}
            height={100}
            className="w-32 h-16 object-contain"
          />
        </div>
      </div>
      {/* Left Nav */}
      <nav className="flex gap-x-14 justify-end font-bold text-2xl child:relative flex-1 py-2 pt-6 font-serif">
        {leftNavItems.map((item) =>
          item.items.length > 0 ? (
            <div
              key={item.label}
              className="cursor-pointer pb-2"
              onMouseEnter={() => handleMenuHover(item.label)}
              onMouseLeave={() => handleMenuHover(null)}
              style={{
                borderBottom:
                  activeMenu === item.label
                    ? "4px solid #8B5C2A"
                    : "4px solid transparent",
              }}
            >
              {item.label}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 w-3 h-3 inline-block ${
                  activeMenu === item.label ? "fa-flip-vertical" : ""
                }`}
              />
              {activeMenu === item.label && (
                <NavigationMenu items={[...item.items]} />
              )}
            </div>
          ) : (
            <Link
              key={item.label}
              to={item.href}
              className={
                pathname === item.href
                  ? "text-primary border-b-4 border-[#8B5C2A] pb-2"
                  : "pb-2 border-b-4 border-transparent"
              }
              style={{
                borderBottom:
                  pathname === item.href
                    ? "4px solid #8B5C2A"
                    : "4px solid transparent",
              }}
            >
              {item.label}
            </Link>
          )
        )}
      </nav>
      {/* Spacer for logo overlap */}
      <div className="w-1/3" />
      {/* Right Nav */}
      <nav className="flex gap-x-14 justify-start font-bold text-2xl child:relative flex-1 py-2 pt-6 font-serif">
        {rightNavItems.map((item) =>
          item.items.length > 0 ? (
            <div
              key={item.label}
              className="cursor-pointer pb-2"
              onMouseEnter={() => handleMenuHover(item.label)}
              onMouseLeave={() => handleMenuHover(null)}
              style={{
                borderBottom:
                  activeMenu === item.label
                    ? "4px solid #8B5C2A"
                    : "4px solid transparent",
              }}
            >
              {item.label}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 w-3 h-3 inline-block ${
                  activeMenu === item.label ? "fa-flip-vertical" : ""
                }`}
              />
              {activeMenu === item.label && (
                <NavigationMenu items={[...item.items]} />
              )}
            </div>
          ) : (
            <Link
              key={item.label}
              to={item.href}
              className={
                pathname === item.href
                  ? "text-primary border-b-4 border-[#8B5C2A] pb-2"
                  : "pb-2 border-b-4 border-transparent"
              }
              style={{
                borderBottom:
                  pathname === item.href
                    ? "4px solid #8B5C2A"
                    : "4px solid transparent",
              }}
            >
              {item.label}
            </Link>
          )
        )}
      </nav>
    </div>
  );
};

export default DesktopNav;
